<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <StudioCheckout>
          <template v-slot:breadcrumbs="props">
            <div class="small">
              <div class="d-flex">
                <span
                  class="back-button pointer d-md-none"
                  @click="$router.go(-1)"
                >
                  <i class="fal fa-chevron-left"></i>
                </span>
                <StudioLogo class="logo-image mb-2" :studio="studio" />
              </div>
              <hr class="d-block d-md-none mt-2 mb-3 p-0" />
              <NuxtLink :to="{ name: 'studio-product' }" class="c-coral">
                <span>
                  {{ props.product.product_name }}
                </span>
              </NuxtLink>
              <span class="mx-2 mx-md-3"
                ><i class="fal fa-chevron-right"></i
              ></span>
              <span class="c-charcoal">{{
                $t('STUDIO.LABELS.BREADCRUMB_CHECKOUT')
              }}</span>
            </div>
          </template>
        </StudioCheckout>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import api from '~/api/products';
const { $studioURL } = useNuxtApp();
const route = useRoute();
const productId = route.params.product_id;

definePageMeta({
  name: 'studio-product-checkout',

  isStudio: true,
  hideInstagramSlider: true,
  hideTopBar: true,
  hideStudioContactInformation: true,
  preventRefreshModal: true,
  hideMobileNav: true,
  hideCookieNotice: true
})

try {
  const { data: productBasic } = await useAsyncData('productBasic', () => api.getProductBasic($studioURL, productId))

  const seoMeta = {
    ogTitle: `${productBasic.value.product_name} | ${productBasic.value.studio_name}`,
  }
  if(productBasic.value?.cover_file?.image_url) {
    seoMeta.ogImage = productBasic.value.cover_file?.image_url
  }
  
  useSeoMeta(seoMeta)
} catch (error) {
  console.error(error);
}
</script>


<script lang="ts">
import StudioCheckout from '@/components/checkout/StudioCheckout.vue';
import StudioLogo from '@/components/navigation/StudioLogo.vue';
import { mapState } from 'pinia';
import { useStudioStore } from '@/stores';

export default {
  name: 'StudioProductCheckout',
  components: {
    StudioCheckout,
    StudioLogo,
  },
  computed: {
    ...mapState(useStudioStore, {
      studio: 'currentStudio',
    }),
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/components-variables.scss';

.logo-image {
  display: block;
  height: 60px;
  width: auto;
}

.back-button {
  display: flex;
  align-items: center;
  padding: 0 16px;
  margin-left: -10px;
}
</style>
